import { useTranslations } from "next-intl";
import { useDrawerName, useCloseDrawer } from "@hooks/use-drawer";
import Offcanvas from "@components/core/Offcanvas";
import DrawerLead from "./drawers/DrawerLead";
import DrawerSubscriptionPaused from "./drawers/DrawerSubscriptionPaused";
import DrawerSubscriptionCanceled from "./drawers/DrawerSubscriptionCanceled";
import DrawerClosetRTC from "./drawers/DrawerClosetRTC";
import DrawerClosetRTP from "./drawers/DrawerClosetRTP";
import DrawerClosetInPreparation from "./drawers/DrawerClosetInPreparation";
import DrawerClosetSent from "./drawers/DrawerClosetSent";
import DrawerClosetReceived from "./drawers/DrawerClosetReceived";
import DrawerClosetPostReturned from "./drawers/DrawerClosetPostReturned";
import DrawerClosetReturned from "./drawers/DrawerClosetReturned";
import DrawerClosetUnavailable from "./drawers/DrawerClosetUnavailable";

function Drawers() {
  const t = useTranslations("common");

  const drawerName = useDrawerName();
  const closeDrawer = useCloseDrawer();

  const renderDrawer = () => {
    switch (drawerName) {
      case "visitor":
      case "user_lead":
        return <DrawerLead />;
      case "subscription_paused":
        return <DrawerSubscriptionPaused />;
      case "subscription_canceled":
        return <DrawerSubscriptionCanceled />;
      case "closet_ready_to_change":
        return <DrawerClosetRTC />;
      case "closet_ready_to_pack":
        return <DrawerClosetRTP />;
      case "closet_invoicing":
      case "closet_preparable":
      case "closet_in_preparation":
        return <DrawerClosetInPreparation />;
      case "closet_sent":
        return <DrawerClosetSent />;
      case "closet_received":
        return <DrawerClosetReceived />;
      case "closet_post_returned":
        return <DrawerClosetPostReturned />;
      case "closet_returned":
        return <DrawerClosetReturned />;
      case "closet_empty":
      case "closet_purchased":
      case "closet_lost":
        return <DrawerClosetUnavailable />;
      default:
        return null;
    }
  };

  return (
    <Offcanvas
      show={!!drawerName}
      onHide={closeDrawer}
      title={t("drawer.header.my_closet")}
      placement="end"
    >
      {renderDrawer()}
    </Offcanvas>
  );
}

export default Drawers;
